import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';
import { Color } from 'shared/utils/colors';

const useStyles = makeStyles({
  outlinedButton: {
    fontSize: '1rem',
    fontWeight: 600,
    paddingLeft: 12,
    paddingRight: 12,
    // Match the app-wide secondary outline: thin dark border, 4px radius, brand
    // yellow hover (the global 2px primary outline reads too heavy here).
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px !important',
    borderColor: Color.black,
    backgroundColor: 'transparent',
    color: Color.black,
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: Color.black,
      backgroundColor: Color.primaryOrangeHover,
    },
    '&.Mui-disabled': {
      borderColor: Color.disabledGray,
    },
  },
});

type ButtonOutlinedProps = PropsWithChildren<any>;

const ButtonOutlined = ({
  children,
  ...props
}: ButtonOutlinedProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Button
      {...props}
      color='primary'
      variant='outlined'
      className={classNames(props.className, classes.outlinedButton)}
    >
      {children}
    </Button>
  );
};

export default ButtonOutlined;
